import { EventEmitter, Injectable, Output } from "@angular/core";

@Injectable()
export abstract class ModalAbstractComponent<_T> {
  @Output() public closeModal = new EventEmitter<any>();

  @Output() public dismissModal = new EventEmitter<any>();

  public close(data?: any): void {
    this.closeModal.emit(data);
  }

  public dismiss(): void {
    this.dismissModal.emit(null);
  }
}
